import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.mjs";
import { __require as o } from "../node_modules/json2mq/index.mjs";
var t = o();
const s = /* @__PURE__ */ r(t);
export {
  s as default
};
